import React, { useState, useEffect } from 'react'
import {
  ButtonGroup,
  CheckPicker,
  Col,
  ControlLabel,
  Icon,
  IconButton,
  Input,
  InputGroup,
  Message,
  Panel,
  Rate,
  Row,
  SelectPicker,
  Uploader,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import {
  getMaxLengthData,
  isImageOrPdf,
  isValidators,
  requiredFiled,
} from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import notification from '../../utils/notification'
import { cloneDeep, isEmpty } from 'lodash-es'
import ShowLimitLength from '../../components/utils/ShowLimitLength'

export default function ResearchFrom(props) {
  const {
    index,
    itemValue,
    onSubmit = () => {},
    onPreview = () => {},
    onDownload = () => {},
    onDelete = () => {},
    onPreviewFilePath = () => {},
    onDownloadFilePath = () => {},
    isSuccess = false,
  } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [formSchema, setFormSchema] = useState(props.schema)
  const [creatorValue, setCreatorValue] = useState([])
  const [fileTypeError, setFileTypeError] = useState(false)
  const [fileCountError, setFileCountError] = useState(false)
  const [filesImage, setFilesImage] = useState([])
  const [files, setFiles] = useState(null)
  const [fileLists, setFileLists] = useState([])
  const [fileList2, setFileList2] = useState([])
  const [nameOfResearcherValue, setNameOfResearcherValue] = useState([])
  const [formValues, setFormValues] = useState()
  const [fullDescriptionVal, setFullDescriptionVal] = useState()
  const [descriptionVal, setDescriptionVal] = useState()
  const [paperResultVal, setPaperResultVal] = useState()

  const rowStyle = { marginTop: 5 }

  useEffect(() => {
    // const countValues = formSchema?.values?.length || 0

    console.log('itemValue.id => ', itemValue.id)

    setFullDescriptionVal(itemValue.fullDescription || '')
    setDescriptionVal(itemValue.description || '')
    setPaperResultVal(itemValue.paperResult || '')

    console.log('itemValue.attachFiles res => ', itemValue.attachFiles)
    console.log('fileLists ggg => ', fileLists)

    setFilesImage(itemValue.attachFiles)

    let newArr = []
    if (itemValue?.nameOfResearcher?.length > 0) {
      itemValue.nameOfResearcher.map((item, index) => {
        newArr.push(item)
      })
    } else {
      newArr.push('')
    }

    // setTimeout(() => !itemValue.id && setValueNullField(), 1000)
    setNameOfResearcherValue(newArr)
  }, [itemValue])

  useEffect(() => {
    console.log('isSuccess => ', isSuccess, itemValue.id)
    if (isSuccess) {
      console.log('is runing....')
      setFileLists([])
      setFileList2([])

      setValue(formSchema.input.attachFiles.name, [])
    }
  }, [isSuccess])

  const setValueNullField = () => {
    for (const key in getValues()) {
      // console.log('key => ', key)
      setValue(key, null)
    }
  }

  const setValueName = (index, indexName, value) => {
    const x = cloneDeep(nameOfResearcherValue)

    x[indexName] = value

    setNameOfResearcherValue(x)
  }

  const addItemName = () => {
    const x = cloneDeep(nameOfResearcherValue)

    let newArr = x || []
    newArr.push('')

    setNameOfResearcherValue(newArr)
  }

  const deleteItemName = (index, indexName) => {
    const x = cloneDeep(nameOfResearcherValue)
    x.splice(indexName, 1)

    setNameOfResearcherValue(x)
  }

  const tableAttachFiles = (files) => {
    return (
      <table width={'100%'} border={1}>
        <thead>
          <tr>
            <th width="10%" style={{ textAlign: 'center' }}>
              <p style={{ padding: 3 }}>ลำดับ</p>
            </th>
            <th width="70%">
              <p style={{ padding: 3 }}>{`ไฟล์ (รวม ${filesImage?.length} ไฟล์)`}</p>
            </th>
            <th width="20%">
              <p style={{ padding: 3 }}>#</p>
            </th>
          </tr>
        </thead>
        <tbody>
          {filesImage?.map((item, index) => {
            return (
              <tr>
                <td align="center">{index + 1}</td>
                <td>
                  <p style={{ padding: 3 }}>{item.label}</p>
                </td>
                <td align="center">
                  <div style={{ padding: 3 }}>
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        size="sm"
                        icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                        onClick={() => onPreview(item)}
                        // disabled={!item?.path}
                      />
                      <IconButton
                        appearance="ghost"
                        size="sm"
                        icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                        onClick={() => onDownload(item)}
                        // disabled={!item?.path}
                      />
                      <IconButton
                        appearance="ghost"
                        size="sm"
                        className="rs-btn-ghost-cancel"
                        icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
                        disabled={filesImage.length == 1}
                        onClick={() => onDelete(item, itemValue.id)}
                        // disabled={!item?.path}
                      />
                    </ButtonGroup>
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }

  const tableAttachSingleFiles = (files) => {
    return (
      <table width={'100%'} border={1}>
        <thead>
          <tr>
            <th width="10%" style={{ textAlign: 'center' }}>
              <p style={{ padding: 3 }}>ลำดับ</p>
            </th>
            <th width="70%">
              <p style={{ padding: 3 }}>{`ไฟล์`}</p>
            </th>
            <th width="20%">
              <p style={{ padding: 3 }}>#</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td align="center">{1}</td>
            <td>
              <p style={{ padding: 3 }}>{files.slice(13)}</p>
            </td>
            <td align="center">
              <div style={{ padding: 3 }}>
                <ButtonGroup>
                  <IconButton
                    appearance="ghost"
                    size="sm"
                    icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                    onClick={() => onPreviewFilePath(files)}
                    // disabled={!item?.path}
                  />
                  <IconButton
                    appearance="ghost"
                    size="sm"
                    icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                    onClick={() => onDownloadFilePath(files)}
                    // disabled={!item?.path}
                  />
                  {/* <IconButton
                    appearance="ghost"
                    size="sm"
                    className="rs-btn-ghost-cancel"
                    icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
                    // onClick={() => onDelete(item)}
                    // disabled={!item?.path}
                  /> */}
                </ButtonGroup>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  return (
    <>
      <Panel
        // shaded
        collapsible
        defaultExpanded
        header={`${formSchema.header}ที่ ${index + 1}`}
        bordered
        key={index}
        style={{ marginBottom: 10 }}
      >
        <Row style={{ display: 'none' }}>
          {/* <Row> */}
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            Id :{' '}
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <Input
              key={'id'}
              name={'id'}
              defaultValue={itemValue?.id || ''}
              value={itemValue?.id || ''}
              inputRef={register()}
            />
            <Input
              key={'progressId'}
              name={'progressId'}
              defaultValue={itemValue?.progressId || ''}
              value={itemValue?.progressId || ''}
              inputRef={register()}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.input.nameTh.validators, formSchema.input.nameTh.label)}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <ErrorMessage error={errors[`${formSchema.input.nameTh.name}`]} />
            <Input
              key={`${formSchema.input.nameTh.name}`}
              name={`${formSchema.input.nameTh.name}`}
              defaultValue={itemValue.nameTh || ''}
              disabled={formSchema.input.nameTh.disabled}
              inputRef={register(isValidators(formSchema.input.nameTh.validators))}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.input.nameEng.validators, formSchema.input.nameEng.label)}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <ErrorMessage error={errors[`${formSchema.input.nameEng.name}`]} />
            <Input
              key={`${formSchema.input.nameEng.name}`}
              name={`${formSchema.input.nameEng.name}`}
              defaultValue={itemValue.nameEng || ''}
              disabled={formSchema.input.nameEng.disabled}
              inputRef={register(isValidators(formSchema.input.nameEng.validators))}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.input.fullDescription.validators,
                formSchema.input.fullDescription.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <ErrorMessage error={errors[`${formSchema.input.fullDescription.name}`]} />
            <Input
              key={index}
              componentClass="textarea"
              name={`${formSchema.input.fullDescription.name}`}
              defaultValue={itemValue.fullDescription || ''}
              disabled={formSchema.input.fullDescription.disabled}
              inputRef={register(isValidators(formSchema.input.fullDescription.validators))}
              maxLength={getMaxLengthData(formSchema.input.fullDescription.validators)?.value}
              onChange={(value) => {
                setFullDescriptionVal(value)
              }}
            />
            <ShowLimitLength
              textLength={fullDescriptionVal?.length || 0}
              maxLength={getMaxLengthData(formSchema.input.fullDescription.validators)?.value}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.input.description.validators,
                formSchema.input.description.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <ErrorMessage error={errors[`${formSchema.input.description.name}`]} />
            <Input
              key={index}
              componentClass="textarea"
              name={`${formSchema.input.description.name}`}
              defaultValue={itemValue.description || ''}
              disabled={formSchema.input.description.disabled}
              inputRef={register(isValidators(formSchema.input.description.validators))}
              maxLength={getMaxLengthData(formSchema.input.description.validators)?.value}
              onChange={(value) => {
                setDescriptionVal(value)
              }}
            />
            <ShowLimitLength
              textLength={descriptionVal?.length || 0}
              maxLength={getMaxLengthData(formSchema.input.description.validators)?.value}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.input.paperResult.validators,
                formSchema.input.paperResult.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <ErrorMessage error={errors[`${formSchema.input.paperResult.name}`]} />
            <Input
              key={index}
              componentClass="textarea"
              name={`${formSchema.input.paperResult.name}`}
              defaultValue={itemValue.paperResult || ''}
              disabled={formSchema.input.paperResult.disabled}
              inputRef={register(isValidators(formSchema.input.paperResult.validators))}
              maxLength={getMaxLengthData(formSchema.input.paperResult.validators)?.value}
              onChange={(value) => {
                setPaperResultVal(value)
              }}
            />
            <ShowLimitLength
              textLength={paperResultVal?.length || 0}
              maxLength={getMaxLengthData(formSchema.input.paperResult.validators)?.value}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.input.issue.validators, formSchema.input.issue.label)}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <ErrorMessage error={errors[`${formSchema.input.issue.name}`]} />
            <Controller
              key={`${formSchema.input.issue.name}`}
              name={`${formSchema.input.issue.name}`}
              control={control}
              defaultValue={itemValue.issue || null}
              rules={isValidators(formSchema.input.issue.validators)}
              render={(props) => {
                return (
                  <>
                    <CheckPicker
                      data={formSchema.input.issue.options}
                      value={props.value}
                      style={{ width: '100%' }}
                      placeholder="เลือก"
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                    />

                    {props?.value?.find((item) => item == '999') && (
                      <div style={rowStyle}>
                        <ErrorMessage error={errors[`${formSchema.input.issue.otherIssue.name}`]} />
                        <Input
                          key={`${formSchema.input.issue.otherIssue.name}`}
                          name={`${formSchema.input.issue.otherIssue.name}`}
                          placeholder={`${formSchema.input.issue.otherIssue.label} ระบุ`}
                          defaultValue={itemValue.otherIssue || ''}
                          disabled={formSchema.input.issue.otherIssue.disabled}
                          inputRef={register(
                            isValidators(formSchema.input.issue.otherIssue.validators)
                          )}
                        />
                      </div>
                    )}
                  </>
                )
              }}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.input.target.validators, formSchema.input.target.label)}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <ErrorMessage error={errors[`${formSchema.input.target.name}`]} />
            <Controller
              key={`${formSchema.input.target.name}`}
              name={`${formSchema.input.target.name}`}
              control={control}
              defaultValue={itemValue.target || null}
              rules={isValidators(formSchema.input.target.validators)}
              render={(props) => {
                return (
                  <>
                    <CheckPicker
                      data={formSchema.input.target.options}
                      value={props.value}
                      style={{ width: '100%' }}
                      placeholder="เลือก"
                      onChange={(value) => {
                        props.onChange(value)
                      }}
                    />

                    {props?.value?.find((item) => item == '999') && (
                      <div style={rowStyle}>
                        <ErrorMessage
                          error={errors[`${formSchema.input.target.otherTarget.name}`]}
                        />
                        <Input
                          key={`${formSchema.input.target.otherTarget.name}`}
                          name={`${formSchema.input.target.otherTarget.name}`}
                          placeholder={`${formSchema.input.target.otherTarget.label} ระบุ`}
                          defaultValue={itemValue.otherTarget || ''}
                          disabled={formSchema.input.target.otherTarget.disabled}
                          inputRef={register(
                            isValidators(formSchema.input.target.otherTarget.validators)
                          )}
                        />
                      </div>
                    )}
                  </>
                )
              }}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        {/*<Row style={rowStyle}>*/}
        {/*  <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>*/}
        {/*    <ControlLabel>*/}
        {/*      {requiredFiled(*/}
        {/*        formSchema.input.importance.validators,*/}
        {/*        formSchema.input.importance.label*/}
        {/*      )}*/}
        {/*    </ControlLabel>*/}
        {/*  </Col>*/}
        {/*  <Col lg={16} md={16} sm={16} xs={16}>*/}
        {/*    <ErrorMessage*/}
        {/*      error={errors[`${formSchema.input.importance.name}`]}*/}
        {/*    />*/}
        {/*    <Input*/}
        {/*      key={`${formSchema.input.importance.name}`}*/}
        {/*      name={`${formSchema.input.importance.name}`}*/}
        {/*      defaultValue={formSchema.input.importance.value}*/}
        {/*      disabled={formSchema.input.importance.disabled}*/}
        {/*      inputRef={register(isValidators(formSchema.input.importance.validators))}*/}
        {/*    />*/}
        {/*  </Col>*/}
        {/*  <Col lg={2} md={2} sm={2} xs={2}></Col>*/}
        {/*</Row>*/}
        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.input.objective.validators,
                formSchema.input.objective.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <ErrorMessage error={errors[`${formSchema.input.objective.name}`]} />
            <Input
              key={`${formSchema.input.objective.name}`}
              name={`${formSchema.input.objective.name}`}
              defaultValue={itemValue.objective || ''}
              disabled={formSchema.input.objective.disabled}
              inputRef={register(isValidators(formSchema.input.objective.validators))}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(formSchema.input.benefit.validators, formSchema.input.benefit.label)}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <ErrorMessage error={errors[`${formSchema.input.benefit.name}`]} />
            <Input
              key={`${formSchema.input.benefit.name}`}
              name={`${formSchema.input.benefit.name}`}
              defaultValue={itemValue.benefit || ''}
              disabled={formSchema.input.benefit.disabled}
              inputRef={register(isValidators(formSchema.input.benefit.validators))}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        {nameOfResearcherValue.length >= 0 &&
          nameOfResearcherValue.map((itemName, indexName) => {
            return (
              <Row style={rowStyle}>
                <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      formSchema.input.nameOfResearcher.validators,
                      `${formSchema.input.nameOfResearcher.label} (${indexName + 1})`
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={16} md={16} sm={16} xs={16}>
                  {nameOfResearcherValue[indexName]?.length <= 0 && (
                    <Message
                      type="error"
                      description={`${
                        formSchema.input.nameOfResearcher.validators[0].errorMessage
                      } (${indexName + 1})`}
                    />
                  )}

                  <ErrorMessage
                    error={errors[`${formSchema.input.nameOfResearcher.name}_${indexName}`]}
                  />
                  <InputGroup>
                    <Input
                      key={`${formSchema.input.nameOfResearcher.name}[${indexName}]`}
                      name={`${formSchema.input.nameOfResearcher.name}[${indexName}]`}
                      // defaultValue={formSchema.input.nameOfResearcher.value}
                      // defaultValue={itemName || ''}
                      value={itemName || ''}
                      disabled={formSchema.input.nameOfResearcher.disabled}
                      inputRef={register(
                        isValidators(formSchema.input.nameOfResearcher.validators)
                      )}
                      onChange={(value) => {
                        // console.log('val => ', value)
                        setValueName(index, indexName, value)
                      }}
                    />

                    {indexName == 0 ? (
                      <>
                        <InputGroup.Button
                          color="green"
                          // onClick={() => addItemCreator(itemCreator, indexCreator)}
                          onClick={() => addItemName()}
                        >
                          <Icon icon="plus-circle" />
                        </InputGroup.Button>
                      </>
                    ) : (
                      <>
                        <InputGroup.Button
                          color="red"
                          onClick={() => deleteItemName(index, indexName)}
                        >
                          <Icon icon="minus-circle" />
                        </InputGroup.Button>
                      </>
                    )}
                  </InputGroup>
                </Col>
                <Col lg={2} md={2} sm={2} xs={2}></Col>
              </Row>
            )
          })}
        {/* <Row style={rowStyle}>
                    <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
                      <ControlLabel>
                        {requiredFiled(
                          formSchema.input.nameOfResearcher.validators,
                          formSchema.input.nameOfResearcher.label
                        )}
                      </ControlLabel>
                    </Col>
                    <Col lg={16} md={16} sm={16} xs={16}>
                      <ErrorMessage
                        error={errors[`${formSchema.input.nameOfResearcher.name}`]}
                      />
                      <Input
                        key={`${formSchema.input.nameOfResearcher.name}`}
                        name={`${formSchema.input.nameOfResearcher.name}`}
                        defaultValue={formSchema.input.nameOfResearcher.value}
                        disabled={formSchema.input.nameOfResearcher.disabled}
                        inputRef={register(
                          isValidators(formSchema.input.nameOfResearcher.validators)
                        )}
                      />
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}></Col>
                  </Row> */}
        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.input.yearOfDevelopment.validators,
                formSchema.input.yearOfDevelopment.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <ErrorMessage error={errors[`${formSchema.input.yearOfDevelopment.name}`]} />
            <Controller
              key={`${formSchema.input.yearOfDevelopment.name}`}
              name={`${formSchema.input.yearOfDevelopment.name}`}
              control={control}
              defaultValue={
                itemValue.yearOfDevelopment ? itemValue.yearOfDevelopment.toString() : null
              }
              rules={isValidators(formSchema.input.yearOfDevelopment.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    searchable
                    data={formSchema.input.yearOfDevelopment.options}
                    value={props.value}
                    style={{ width: '100%' }}
                    placeholder="เลือก"
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.input.attachFiles.validators,
                formSchema.input.attachFiles.header
              )}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <br />

            {/* {fileCountError && (
              <Message
                style={{ marginTop: 10, marginBottom: 10 }}
                showIcon
                type="error"
                description={'แนบรูปภาพประกอบ (1-10) รูป'}
              />
            )} */}

            {filesImage?.length <= 0 ||
              (isEmpty(filesImage) && (
                <Message
                  style={{ marginTop: 10, marginBottom: 10 }}
                  showIcon
                  type="error"
                  description={formSchema.input.attachFiles.description}
                />
              ))}

            {fileTypeError && (
              <Message
                style={{ marginTop: 10, marginBottom: 10 }}
                closable
                onClose={() => {
                  setFileTypeError(false)
                }}
                showIcon
                type="error"
                description="อัพโหลดไฟล์เป็นรูปภาพเท่านั้น *** ชนิดที่รองรับ png , jpeg , jpg"
              />
            )}
            <ErrorMessage error={errors[`${formSchema.input.attachFiles.name}`]} />
            <Controller
              key={`${formSchema.input.attachFiles.name}`}
              name={`${formSchema.input.attachFiles.name}`}
              control={control}
              rules={isEmpty(filesImage) && isValidators(formSchema.input.attachFiles.validators)}
              defaultValue={''}
              render={(props) => {
                return (
                  <>
                    <p
                      style={{ fontSize: 'small', color: 'red' }}
                    >{`  *อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                      formSchema.input.attachFiles.fileType || '.jpg, .jpeg, .png'
                    } , ขนาดไฟล์ไม่เกิน ${
                      formSchema.input.attachFiles.fileSize || defaultMaxFileSize
                    } MB`}</p>
                    <Uploader
                      accept={formSchema.input.attachFiles.fileType || '.jpg, .jpeg, .png'}
                      autoUpload={false}
                      disabled={filesImage?.length >= 10}
                      fileListVisible={true}
                      listType="picture-text"
                      // fileList={props.value || []}
                      fileList={fileLists || []}
                      multiple
                      onChange={(fileList) => {
                        const fl = fileList?.length || 0
                        const fi = filesImage?.length || 0
                        const countFile = fl + fi

                        if (countFile > 10) {
                          props.onChange(undefined)

                          notification.open('error', {
                            title: formSchema.input.attachFiles.description,
                            duration: 5000,
                          })

                          setFileCountError(true)
                          return false
                        }

                        if (isEmpty(fileList)) {
                          // console.log('isEmpty')
                          props.onChange(undefined)
                          setFileLists([])
                        } else {
                          setFileCountError(false)
                          setFileLists(fileList)
                          fileList.map((_, index) => {
                            let file = fileList[index]

                            if (
                              file.blobFile.size >
                              (formSchema?.input.attachFiles?.fileSize || defaultMaxFileSize) *
                                1024 *
                                1024
                            ) {
                              notification.open('error', {
                                title: `ขนาดไฟล์เกิน ${
                                  formSchema.input.attachFiles.fileSize || defaultMaxFileSize
                                } MB`,
                                duration: 5000,
                              })
                              return
                            }

                            if (isImageOrPdf(file.blobFile.type)) {
                              props.onChange(fileList)
                              setFileTypeError(false)
                            } else {
                              setFileTypeError(true)
                              notification.open('error', {
                                title:
                                  'ชนิดที่รองรับ ' + formSchema.input.attachFiles.fileType ||
                                  '.jpg, .jpeg, .png',
                                duration: 5000,
                              })
                            }
                          })
                        }
                      }}
                      draggable
                    >
                      <div>
                        <Icon size="2x" icon="upload2" />
                        <small className="uploder__text">{`   ${formSchema.input.attachFiles.description}`}</small>
                      </div>
                    </Uploader>
                  </>
                )
              }}
            />
            <br />
            {filesImage?.length > 0 && <div style={{ marginTop: 10 }}>{tableAttachFiles()}</div>}
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        {/* <Row style={rowStyle}>
                    <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
                      <ControlLabel>
                        {requiredFiled(
                          formSchema.input.linked.validators,
                          formSchema.input.linked.label
                        )}
                      </ControlLabel>
                    </Col>
                    <Col lg={16} md={16} sm={16} xs={16}>
                      <ErrorMessage error={errors[`${formSchema.input.linked.name}`]} />
                      <Input
                        key={`${formSchema.input.linked.name}`}
                        name={`${formSchema.input.linked.name}`}
                        defaultValue={formSchema.input.linked.value}
                        disabled={formSchema.input.linked.disabled}
                        inputRef={register(isValidators(formSchema.input.linked.validators))}
                      />
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}></Col>
                  </Row> */}
        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.input.completeEditionAttachFiles.validators,
                formSchema.input.completeEditionAttachFiles.header
              )}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <br />

            <ErrorMessage error={errors[`${formSchema.input.completeEditionAttachFiles.name}`]} />
            <Controller
              key={`${formSchema.input.completeEditionAttachFiles.name}`}
              name={`${formSchema.input.completeEditionAttachFiles.name}`}
              control={control}
              rules={
                !itemValue.completeEditionAttachFiles &&
                isValidators(formSchema.input.completeEditionAttachFiles.validators)
              }
              defaultValue={''}
              render={(props) => {
                return (
                  <>
                    <p
                      style={{ fontSize: 'small', color: 'red' }}
                    >{`  *อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                      formSchema.input.completeEditionAttachFiles.fileType || '.jpg, .jpeg, .png'
                    } , ขนาดไฟล์ไม่เกิน ${
                      formSchema.input.completeEditionAttachFiles.fileSize || defaultMaxFileSize
                    } MB`}</p>
                    <Uploader
                      accept={
                        formSchema.input.completeEditionAttachFiles.fileType || '.jpg, .jpeg, .png'
                      }
                      autoUpload={false}
                      disabled={formSchema.input.completeEditionAttachFiles.disabled}
                      fileListVisible={true}
                      listType="picture-text"
                      // fileList={props.value || []}
                      fileList={fileList2 || []}
                      multiple={false}
                      onChange={(fileList) => {
                        if (isEmpty(fileList)) {
                          props.onChange(undefined)
                          setFileList2([])
                        } else {
                          let file = fileList[fileList.length - 1]

                          if (
                            file.blobFile.size >
                            (formSchema?.input.completeEditionAttachFiles?.fileSize ||
                              defaultMaxFileSize) *
                              1024 *
                              1024
                          ) {
                            notification.open('error', {
                              title: `ขนาดไฟล์เกิน ${
                                formSchema.input.completeEditionAttachFiles.fileSize ||
                                defaultMaxFileSize
                              } MB`,
                              duration: 5000,
                            })
                            return
                          }

                          if (isImageOrPdf(file.blobFile.type)) {
                            let lastFile = [file]
                            setFileList2(lastFile)
                            // console.log('lastFile', lastFile)
                            props.onChange(lastFile)
                            setFileTypeError(false)

                            // props.onChange(fileList)
                            // setFileTypeError(false)
                          } else {
                            setFileTypeError(true)
                            notification.open('error', {
                              title:
                                'ชนิดที่รองรับ ' +
                                  formSchema.input.completeEditionAttachFiles.fileType ||
                                '.jpg, .jpeg, .png',
                              duration: 5000,
                            })
                          }
                        }
                      }}
                      draggable
                    >
                      <div>
                        <Icon size="2x" icon="upload2" />
                        <small className="uploder__text">{`   ${formSchema.input.completeEditionAttachFiles.description}`}</small>
                      </div>
                    </Uploader>
                  </>
                )
              }}
            />

            <br />
            {itemValue.completeEditionAttachFiles &&
              tableAttachSingleFiles(itemValue.completeEditionAttachFiles)}
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <hr />
            <p style={{ color: '#2da888', marginLeft: 15 }}>{formSchema.contactChannels.title}</p>
          </Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.contactChannels.fullName.validators,
                formSchema.contactChannels.fullName.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <ErrorMessage error={errors[`${formSchema.contactChannels.fullName.name}`]} />
            <Input
              key={`${formSchema.contactChannels.fullName.name}`}
              name={`${formSchema.contactChannels.fullName.name}`}
              defaultValue={itemValue.fullName || ''}
              disabled={formSchema.contactChannels.fullName.disabled}
              inputRef={register(isValidators(formSchema.contactChannels.fullName.validators))}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.contactChannels.email.validators,
                formSchema.contactChannels.email.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <ErrorMessage error={errors[`${formSchema.contactChannels.email.name}`]} />
            <Input
              key={`${formSchema.contactChannels.email.name}`}
              name={`${formSchema.contactChannels.email.name}`}
              defaultValue={itemValue.email || ''}
              disabled={formSchema.contactChannels.email.disabled}
              inputRef={register(isValidators(formSchema.contactChannels.email.validators))}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.contactChannels.telephone.validators,
                formSchema.contactChannels.telephone.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <ErrorMessage error={errors[`${formSchema.contactChannels.telephone.name}`]} />
            <Input
              key={`${formSchema.contactChannels.telephone.name}`}
              name={`${formSchema.contactChannels.telephone.name}`}
              type="number"
              defaultValue={itemValue.telephone || ''}
              disabled={formSchema.contactChannels.telephone.disabled}
              inputRef={register(isValidators(formSchema.contactChannels.telephone.validators))}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.contactChannels.agency.validators,
                formSchema.contactChannels.agency.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <ErrorMessage error={errors[`${formSchema.contactChannels.agency.name}`]} />
            <Input
              key={`${formSchema.contactChannels.agency.name}`}
              name={`${formSchema.contactChannels.agency.name}`}
              defaultValue={itemValue.agency || ''}
              disabled={formSchema.contactChannels.agency.disabled}
              inputRef={register(isValidators(formSchema.contactChannels.agency.validators))}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <hr />
            <p style={{ color: '#2da888', marginLeft: 15 }}>{formSchema.evaluationTitile}</p>
          </Col>
        </Row>
        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.input.criteria1.validators,
                formSchema.input.criteria1.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <ErrorMessage error={errors[`${formSchema.input.criteria1.name}`]} />
            <Controller
              key={`${formSchema.input.criteria1.name}`}
              name={`${formSchema.input.criteria1.name}`}
              control={control}
              defaultValue={itemValue.criteria1 ? itemValue.criteria1.toString() : null}
              rules={isValidators(formSchema.input.criteria1.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    searchable={false}
                    data={formSchema.input.criteria1.options}
                    value={props.value}
                    block
                    placeholder="เลือก"
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.input.criteria2.validators,
                formSchema.input.criteria2.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <ErrorMessage error={errors[`${formSchema.input.criteria2.name}`]} />
            <Controller
              key={`${formSchema.input.criteria2.name}`}
              name={`${formSchema.input.criteria2.name}`}
              control={control}
              defaultValue={itemValue.criteria2 ? itemValue.criteria2.toString() : null}
              rules={isValidators(formSchema.input.criteria2.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    searchable={false}
                    data={formSchema.input.criteria2.options}
                    value={props.value}
                    block
                    placeholder="เลือก"
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.input.criteria3.validators,
                formSchema.input.criteria3.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <ErrorMessage error={errors[`${formSchema.input.criteria3.name}`]} />
            <Controller
              key={`${formSchema.input.criteria3.name}`}
              name={`${formSchema.input.criteria3.name}`}
              control={control}
              defaultValue={itemValue.criteria3 ? itemValue.criteria3.toString() : null}
              rules={isValidators(formSchema.input.criteria3.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    searchable={false}
                    data={formSchema.input.criteria3.options}
                    value={props.value}
                    block
                    placeholder="เลือก"
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>
        <hr />
        <Row style={rowStyle}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ marginBottom: 10 }}>
            {itemValue.typeSendFlag && itemValue.strSendFlag && (
              <div>
                <Message
                  showIcon
                  type={itemValue.typeSendFlag}
                  // title={itemValue.strSendFlag}
                  description={itemValue.strSendFlag}
                />
              </div>
            )}
          </Col>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <SaveButton
              onClick={handleSubmit(onSubmit)}
              // disabled={isLoading || schema?.reviewerFilter?.disabled}
            >
              {formSchema.buttonText.saveButtonName}
            </SaveButton>
          </Col>
        </Row>
      </Panel>
    </>
  )
}
